import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';

const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponents.errorProvider.';

const TITLES = {
    [AppErrorEnumeration.CUSTOMER_AUTHORIZATION_FAILED]: `${DOMAIN}noCustomerAuthorizationTitle`,
    [AppErrorEnumeration.CHECKOUT_NO_INFO]: `${DOMAIN}noInfoTitle`,
    [AppErrorEnumeration.NO_ONE_TOKEN]: `${DOMAIN}noTokenTitle`,
    [AppErrorEnumeration.STATE_FAILED]: `${DOMAIN}stateFailedTitle`,
    [AppErrorEnumeration.UNKNOWN_ERROR]: `${DOMAIN}unknownErrorTitle`,
  },
  DESCRIPTIONS = {
    [AppErrorEnumeration.CUSTOMER_AUTHORIZATION_FAILED]: `${DOMAIN}noCustomerAuthorizationDescription`,
    [AppErrorEnumeration.CHECKOUT_NO_INFO]: `${DOMAIN}noInfoDescription`,
    [AppErrorEnumeration.NO_ONE_TOKEN]: `${DOMAIN}noTokenDescription`,
    [AppErrorEnumeration.STATE_FAILED]: `${DOMAIN}stateFailedDescription`,
    [AppErrorEnumeration.UNKNOWN_ERROR]: `${DOMAIN}unknownErrorDescription`,
  },
  BUTTON = `${DOMAIN}button`;

export { BUTTON, DESCRIPTIONS, TITLES };
